<template>
  <PaOverlayModal
  :appendClass="['pa-overlay-modal-default-transition-fix-for-tutorial', 'pa-tutorial-modal']"
  :additionalZIndex="2"
  :isOpen="isOpen"
  :position="{top: .15}"
  :isFreez="isFreezModal"
  :couldOverlaySwipeClose="false"
  contentTransitionName="trans-content"

  @closeOverlayModal="handleCloseOverlay"
  @afterEnterContent="handleEnterContent"
  @afteredAfterEnterContent="handleAfterEnterContent"
  @afterLeaveContent="handleAfterLeaveContent"
  >
    <div class="pa-tutorial-entrance">
      <p class="city-name">塔経市帝</p>
      <p class="organization">２４区番外地管理局管轄</p>
      <p class="site-name">異界舞踏会・アキバトリカル<span class="conjuction">へ</span></p>
      <p class="greet">ようこそ、いらっしゃいました。</p>
      <hr class="pa-separator" />
      <p class="sentence-1">皆様の常識とは少し異なる</p>
      <p class="sentence-2">異世界のSNS</p>
      <p class="sentence-3">只今より、ご案内申し上げます。</p>
      <div class="button-field">
        <button
         class="button pa-button"
         @click.prevent="handleClickSubmit"
        >チュートリアルを開始する</button>
      </div>
      <div class="button-field cancel-button-field">
        <button
         class="button pa-button pa-button-line"
         @click.prevent="handleCancel"
        >チュートリアルをスキップする</button>
      </div>
    </div>
  </PaOverlayModal>
</template>

<script>
import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'
export default {
  props : {
    isOpen: {
      default: false
    }
  },

  components : {
    PaOverlayModal
  },

  data(){
    return {
      isFreezModal      : false,
      isLoadedModal     : false,
    };
  },

  watch : {
    isLoadedModal(value){
      if(value === true){
        this.$emit('loadedModal');
      }
    }
  },

  methods : {
    handleCloseOverlay(){
      this.$emit('closeOverlay');
    },

    handleEnterContent(){
      this.isFreezModal = true;
    },

    handleAfterEnterContent(){
      this.$nextTick(() => {
        this.isLoadedModal = true;
      });
    },

    handleAfterLeaveContent(){
      this.isFreezModal = false;
    },

    handleClickSubmit(){
      this.$emit('onSubmit');
    },

    handleCancel(){
      this.$emit('onCancel');
    },
  }
}
</script>

<style lang="scss">
.pa-tutorial-modal{
  .pa-tutorial-entrance{
    p{
      color:#ffffff;
      text-align: center;
      font-size:1rem;
      
      &.city-name{
        font-size:.8rem;
        margin-bottom:-.1rem;
      }

      &.organization{
        font-size:1.2rem;
        margin-bottom:.3rem;
      }

      &.site-name{
        font-size: 1.4rem;
        margin-bottom: .3rem;
        letter-spacing: 2px;
        
        span.conjuction{
          margin-left: 10px;
        }
      }

      &.greet{
        font-size:1.1rem;
      }

      &.sentence-1{
        font-size:1.1rem;
        margin-bottom:.5rem;
      }

      &.sentence-2{
        font-size:1.4rem;
        margin:.7rem 0 .4rem;
      }

      &.sentence-3{
        font-size:1.1rem;
      }
    }

    hr.pa-separator{
      display: block;
      width:30%;
      margin:1.1rem auto;
    }

    .button-field{
      margin:1rem 0;

      button.pa-button{
        display: block;
        width:70%;
        margin:0 auto;
        border:2px solid #A4734B;
        background-color:#C49065;
        border-radius: 20px;
        color:#5E3717;

        &.is-loading::after{
          border: 1.3px solid #5E3717;
          border-right-color: transparent;
          border-top-color: transparent;
        }
      }
    }

    .cancel-button-field{
      position: fixed;
      bottom:0;

      button.pa-button-line{
        width: inherit;
        display: inline;
        margin-top:2rem;
        margin-left:.5rem;
        font-size:.8rem;
        padding:0;
        border:none;
        background-color: inherit;
        height: inherit;
        line-height: 1.3;
        border-radius:inherit;
        border-bottom:1px solid #CEC7C7;
        color:#CEC7C7;
      }
    }
  }
}
</style>